<template>
  <div class="coop-c-steps">
    <p class="coop-t-bold coop-u-margin-b-8">
      Step {{ surveyStore.step }} of {{ surveyStore.totalSteps }}
    </p>
    <div class="coop-c-pills">
      <AtomPill
        v-for="step in surveyStore.totalSteps"
        :key="step"
        :active="step <= surveyStore.step"
      />
    </div>
    <div class="coop-c-steps-question coop-u-padding-t-8">
      <SurveyStep :key="surveyStore.step" />
    </div>
  </div>
</template>

<script setup>
import { computed } from 'vue';
// eslint-disable-next-line import/no-unresolved
import { useSurveyStore } from '@/stores/survey.js';
import AtomPill from '../Atom/AtomPill.vue';
import SurveyStep1 from './SurveyStep1.vue';
import SurveyStep2 from './SurveyStep2.vue';
import SurveyStep3 from './SurveyStep3.vue';
import SurveyStep4 from './SurveyStep4.vue';
import SurveyStep5 from './SurveyStep5.vue';
import SurveyStep6 from './SurveyStep6.vue';
import SurveyStep7 from './SurveyStep7.vue';

const surveyStore = useSurveyStore();

const SurveySteps = [
  SurveyStep1,
  SurveyStep2,
  SurveyStep3,
  SurveyStep4,
  SurveyStep5,
  SurveyStep6,
  SurveyStep7,
];

const SurveyStep = computed(() => {
  return SurveySteps[surveyStore.step - 1];
});

</script>

<style lang="scss" scoped>

</style>
